// UserSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { changePassword, editProfile } from '../../services/userService';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        errors : [],
        loader : false,
        isSuccess: false
    },
    reducers: {},
    extraReducers : (builder) => {
        builder
        .addCase(changePassword.pending, (state) => {
            state.loader = true;
            state.errors = null;
          })
          .addCase(changePassword.fulfilled, (state) => {
            state.loader = false;
            state.isSuccess = true
          })
          .addCase(changePassword.rejected, (state, action) => {
            state.loader = false;
            state.errors = action.payload;
            state.isSuccess = false
          })
    }
});

export const {} = userSlice.actions;
export default userSlice.reducer;
